// 9fbef606107a605d69c0edbcd8029e5d 
import EXTRA_POINTS_CONSTANTS from '../ExtraPoints.constants';

export const fetchPromoList = payload => {
  return {
    payload,
    type: EXTRA_POINTS_CONSTANTS.FETCH_PROMO_LIST_CONTENT,
  };
};

export const setPromoList = payload => {
  return {
    payload,
    type: EXTRA_POINTS_CONSTANTS.SET_PROMO_LIST_CONTENT,
  };
};

export const showLoader = () => {
  return {
    type: EXTRA_POINTS_CONSTANTS.SHOW_LOADER,
  };
};

export const hideLoader = () => {
  return {
    type: EXTRA_POINTS_CONSTANTS.HIDE_LOADER,
  };
};
